import { memo } from "react"

const IconBalanceCard = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="5.33333" fill="#7B78E1" fill-opacity="0.3" />
      <path
        d="M5.5 16.5C9.1448 16.5 12.6757 16.9875 16.0312 17.9008C16.5158 18.0327 17 17.6724 17 17.1701V16.5M6.5 7V7.5C6.5 7.77614 6.27614 8 6 8H5.5M5.5 8V7.75C5.5 7.33579 5.83579 7 6.25 7H17.5M5.5 8V14M17.5 7V7.5C17.5 7.77614 17.7239 8 18 8H18.5M17.5 7H17.75C18.1642 7 18.5 7.33579 18.5 7.75V14.25C18.5 14.6642 18.1642 15 17.75 15H17.5M18.5 14H18C17.7239 14 17.5 14.2239 17.5 14.5V15M17.5 15H6.5M6.5 15H6.25C5.83579 15 5.5 14.6642 5.5 14.25V14M6.5 15V14.5C6.5 14.2239 6.27614 14 6 14H5.5M14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11ZM16 11H16.005V11.005H16V11ZM8 11H8.005V11.005H8V11Z"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconBalanceCard)
